export enum ConditionTypeENUM {
  DISCOUNT = 'DISCOUNT',
  SURCHARGE = 'SURCHARGE'
}
